import { Input, Text } from '@wework/dieter-ui'
import * as _ from 'lodash'
import Row from '../../Common/Row'
import React, { useEffect, useState } from 'react'
import { Search, SearchResultData } from 'semantic-ui-react'
import { withFloorMap } from '@wework/react-floormap'

interface Props {
  floorMap?: any
  setSpaceLinked: any
  spaceLinked: any
}

function LinkeableDeskReservable({
  floorMap,
  setSpaceLinked,
  spaceLinked,
}: Props) {
  const [isSelectVisible, setIsSelectVisible] = useState(false)
  const [results, setResults] = useState<any>([])
  const [isLinked, setIsLinked] = useState(spaceLinked ? true : false)
  const [reservables, setReservables] = useState<any>([])
  const [value, setValue] = useState('')
  const [showDetails, setShowDetails] = useState(false)

  useEffect(() => {
    if (!floorMap) {
      return
    }
    const currentFloor = floorMap.getCurrentFloor()

    const reservableList = floorMap.extensions.reservable
      .getReservables()
      .filter(res => res.floorUUID === currentFloor.uuid)

    setReservables(reservableList)
    setResults(reservableList)
  }, [floorMap, floorMap.extensions.reservable])

  useEffect(() => {
    setIsLinked(spaceLinked ? true : false)
    return () => {
      setIsLinked(false)
    }
  }, [spaceLinked])

  const resultRenderer = ({ uuid, officeNumber, floor }) => (
    <>
      <Text style={{ fontWeight: 'bold' }}>{officeNumber}</Text>
      <Text size="small">{uuid}</Text>
    </>
  )

  const onConfirm = (data: SearchResultData) => {
    setSpaceLinked(data)
  }

  const handleSearchChange = React.useCallback(
    (e, data) => {
      setValue(data.value)

      setTimeout(() => {
        if (data.value.length < 1) return setResults(reservables)

        const re = new RegExp(_.escapeRegExp(data.value), 'i')
        const isMatch = result => re.test(result.officeNumber)

        const filteredResults = _.filter(reservables, isMatch)

        setResults(filteredResults)
      }, 300)
    },
    [reservables]
  )

  const getContent = () => {
    switch (isLinked) {
      case true:
        return (
          <div style={styles.container}>
            <div style={{ marginBottom: 16 }}>
              <Row>
                <Text color="grey" size="small">
                  Room Name
                </Text>
                <div
                  style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    right: -8,
                    top: -8,
                    background: 'white',
                    border: '1px solid #E6E6E6',
                    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.08)',
                    borderRadius: 24,
                    width: 24,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    setIsLinked(false)
                    setSpaceLinked(null)
                    setIsSelectVisible(false)
                  }}
                >
                  <Text size="tiny">X</Text>
                </div>
              </Row>
              <Text>{spaceLinked?.officeNumber}</Text>
            </div>
            {!showDetails ? (
              <Text primary size="small" onClick={() => setShowDetails(true)}>
                Details
              </Text>
            ) : (
              <>
                <div>
                  <Text color="grey" size="small">
                    Reservable UUID
                  </Text>
                  <Text>{spaceLinked?.uuid}</Text>
                </div>
                <Text
                  primary
                  size="small"
                  onClick={() => setShowDetails(false)}
                >
                  Hide Details
                </Text>
              </>
            )}
          </div>
        )
      case false:
        if (isSelectVisible) {
          return (
            <div
              style={{
                backgroundColor: 'white',
                minHeight: 180,
                border: '1px solid #CCEAFF',
              }}
            >
              <Search
                defaultOpen={true}
                input={
                  <Input
                    className="searchLinkeables"
                    fluid
                    style={{ borderRadius: 0 }}
                    icon="search"
                    iconPosition={'left'}
                  />
                }
                className="searchLinkeables"
                loading={false}
                minCharacters={2}
                fluid
                style={{ padding: 16 }}
                placeholder="Search"
                onResultSelect={(e, data) => {
                  onConfirm(data.result)
                  setIsLinked(true)
                  setIsSelectVisible(false)
                }}
                onSearchChange={handleSearchChange}
                //@ts-ignore
                resultRenderer={resultRenderer}
                results={results}
                value={value}
              />
            </div>
          )
        }
        return (
          <div
            style={styles.containerNonLinked}
            onClick={() => setIsSelectVisible(true)}
          >
            <Text size="small" primary>
              Link an inventory item
            </Text>
          </div>
        )
    }
  }
  return <div>{getContent()}</div>
}

const styles = {
  container: {
    border: '1px solid #E6E6E6',
    padding: 16,
    width: '100%',
    position: 'relative' as 'relative',
    borderRadius: 8,
  },
  containerNonLinked: {
    background: '#E5F4FF',
    border: '1px solid #B2DFFF',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    minHeight: 125,
  },
}

export default withFloorMap()(LinkeableDeskReservable)
